import useLoginInfo from "hooks/useLoginInfo";
import React, { useEffect, useImperativeHandle, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PinModal from "../PinModal";
import ModalAlert from "../ModalAlert";
import maskEmailAddress from "utils/maskData";
import { toast } from "react-toastify";
import * as walletAction from "store/entities/wallet/action";

const CreateAccessPin = React.forwardRef((props, ref) => {
    const dispatch = useDispatch();
    const {userInfo, updateIsAccessPinSet} = useLoginInfo();
    const { dashboardLoading, dashboard, otpGenerationLoading, otpGeneration, accessPinLoading, accessPin } = useSelector((s) => s.entities.wallet);
    
    
    const [isOpenNewAccessPin, setIsOpenNewAccessPin] = useState(false);
    const [isOpenConfirmAccessPin, setIsOpenConfirmAccessPin] = useState(false);
    const [isOpenOtpNewPin, setIsOpenOtpNewPin] = useState(false);
    const [isOpenModalAlertNewPinSuccess, setIsOpenModalAlertNewPinSuccess] = useState(false);
    
    const [pin, setPin] = useState({
        otp: "",
        accessPin: "",
        accessPinConfirm: "",
    })

    
    useImperativeHandle(ref, () => ({
        initiateCreateAccessPin
    }));
    

    const getDashboard = () => {
        if(!dashboardLoading && (Object.keys(dashboard).length === 0 || dashboard.status !== "success")){
            dispatch(walletAction.getDashboardSilent(userInfo.token));
        }
    }


    const resetPins = () => {
        setPin({ ...pin, otp: "", accessPin: "", accessPinConfirm: "" });
    }
    

    const initiateCreateAccessPin = () => {
        resetPins();
        setIsOpenNewAccessPin(true);
    }
    
    
    useEffect(() => {
        getDashboard();
        // eslint-disable-next-line
    }, [])


    useEffect(() => {
        // if (otpGeneration?.status === "success"){
        if (otpGeneration?.error === false){
            setIsOpenConfirmAccessPin(false);
            setIsOpenOtpNewPin(true);
            dispatch(walletAction.generateOtpReset());
        }
        // eslint-disable-next-line
    }, [otpGeneration])


    useEffect(() => {
        if (accessPin?.status === "success"){
            setIsOpenOtpNewPin(false);
            setIsOpenModalAlertNewPinSuccess(true);
            resetPins();
            dispatch(walletAction.createAccessPinReset());
            // updateIsAccessPinSet(true);
        }
        // eslint-disable-next-line
    }, [accessPin])

    
    return (
        <>

            <PinModal
                target="Access Pin"
                title="Create Access Pin"
                description="Set new access pin"
                pin={(e) => setPin({...pin, accessPin: e})}
                submit={() => {
                    setIsOpenNewAccessPin(false);
                    setIsOpenConfirmAccessPin(true);
                }}
                loading={false}
                modalLoading={dashboardLoading}
                isOpenPin={isOpenNewAccessPin}
                setIsOpenPin={setIsOpenNewAccessPin}
            />


            <PinModal
                target="Access Pin"
                title="Confirm Access Pin"
                description="Please re-enter your access pin"
                pin={(e) => setPin({...pin, accessPinConfirm: e})}
                submit={() => {
                    if (pin.accessPin === pin.accessPinConfirm){
                        if (userInfo.employer.userType === "employer"){
                            dispatch(walletAction.generateOtp(userInfo.token, "access-pin"));
                        }
                        else if (userInfo.employer.userType === "employer-admin" || userInfo.employer.userType === "employer-business-member"){
                            dispatch(walletAction.generateOtpEmployerAdmin(null,'access-pin'));
                        }
                    }
                    else{
                        toast.error("Your access pin does not match");
                    }
                }}
                loading={otpGenerationLoading}
                modalLoading={dashboardLoading}
                isOpenPin={isOpenConfirmAccessPin}
                setIsOpenPin={setIsOpenConfirmAccessPin}
            />


            <PinModal
                target="OTP"
                title="Enter OTP create"
                description={"Enter OTP sent to " + maskEmailAddress(userInfo?.member?.email) + ", to create your new access pin"}
                pin={(e) => setPin({...pin, otp: e})}
                submit={() => {
                    const params = {otp: parseInt(pin.otp), accessPin: pin.accessPin}
                    if (userInfo.employer.userType === "employer"){
                        dispatch(walletAction.createAccessPin(userInfo.token, params));
                    }
                    else if (userInfo.employer.userType === "employer-admin" || userInfo.employer.userType === "employer-business-member"){
                        dispatch(walletAction.createAccessPinEmployerAdmin(params));
                    }
                }}
                loading={accessPinLoading}
                modalLoading={otpGenerationLoading}
                isOpenPin={isOpenOtpNewPin}
                setIsOpenPin={setIsOpenOtpNewPin}
            />


            <ModalAlert
                successText="Access Pin created successfully"
                dismissText="Dismiss"
                isOpenModalAlert={isOpenModalAlertNewPinSuccess}
                setIsOpenModalAlert={setIsOpenModalAlertNewPinSuccess}
                submit={() => {
                    setIsOpenModalAlertNewPinSuccess(false);
                    props.oncomplete();
                }}
            />
            
        </>
    )
})

export default CreateAccessPin;
